import { combineReducers } from "redux";
import { BreakDownReducer } from "./BreakDownReducer";
import { LoginReducer } from "./LoginReducer";
import { PastSeasonReducer } from "./PastSeasonReducer";
import { PopupReducer } from "./PopupReducer";
import { SeasonReducer } from "./SeasonReducer";
import { VideoLibraryReducer } from "./VideoLibraryReducer";
import { StorageManagementReducer } from "./StorageManagementReducer";
import { UploadVideoReducer } from "./UploadVideoReducer";
import { ActivityHistoryReducer } from "./ActivityHistoryReducer";
import { VideoLibraryFilterReducer } from "./VideoLibraryFilterReducer";
import { MangeBreakDownReducer } from "./MangeBreakDownReducer";
import { SchoolAdminDashboardReducer } from "./SchoolAdminDashboardReducer";
import { IntercutVideoReducer } from "./IntercutVideoReducer";
import { SuperAdminDashboardReducer } from "./SuperAdminDashboardReducer";
import { GroupReducer } from "./GroupReducer";
import { TeamAdminReducer } from "./TeamAdminReducer";
import { CoachReducer } from "./CoachReducer";
import { LoadingReducer } from "./LoadingReducer";
import { AthleteReducer } from "./AthleteReducer";
import { VideoStreamingReducer } from "./VideoStreamingReducer";
import { VideoHighlightReducer } from "./VideoHighlightReducer";
import { VideoScheduleReducer } from "./VideoScheduleReducer";
import { VideoLibraryDataTableReducer } from "./VideoLibraryDataTableReducer";
import { FeedPageReducer } from "./FeedPageReducer";
import { ColumnSetReducer } from "./ColumnSetReducer";
import { BreakdownRequestDataReducer } from "./BreakdownRequestsDataReducer";
import { SocketReducer } from "./SocketReducer";

export const reducers = combineReducers({
  loggedInUser: LoginReducer,
  breakDownInformation: BreakDownReducer,
  popupInformation: PopupReducer,
  videoLibraryData: VideoLibraryReducer,
  allSeasonData: SeasonReducer,
  selectedSeasonData: PastSeasonReducer,
  storageManagementData: StorageManagementReducer,
  uploadVideoData: UploadVideoReducer,
  activityHistoryData: ActivityHistoryReducer,
  videoLibraryFilterData: VideoLibraryFilterReducer,
  manageBreakDownData: MangeBreakDownReducer,
  schoolAdminDashboardInformation: SchoolAdminDashboardReducer,
  IntercutVideoData: IntercutVideoReducer,
  SuperAdminDashboardData: SuperAdminDashboardReducer,
  GroupsData: GroupReducer,
  TeamAdminData: TeamAdminReducer,
  CoachData: CoachReducer,
  LoadingData: LoadingReducer,
  AthleteData: AthleteReducer,
  videoStreamData: VideoStreamingReducer,
  videoHighlightData: VideoHighlightReducer,
  videoScheduleInformation: VideoScheduleReducer,
  VideoLibraryDataTable: VideoLibraryDataTableReducer,
  FeedPageData: FeedPageReducer,
  ColumnSetData: ColumnSetReducer,
  BreakdownRequestData: BreakdownRequestDataReducer,
  SocketData: SocketReducer,
});
